import React, { Fragment } from 'react';

import { ColorConstants } from '@shared/constants';
import Loading from '@shared/components/loading/Loading';
import { CircleIcon } from '@shared/components/icons/svgs';
import { getMetricViewProps } from '@shared/utils/metrics.utils';
import { AccountInfoMetricTitle, AccountInfoMetricValue, AccountInfoMetricWrapper } from './account-info-metric.styles';

interface AccountInfoMetricProps {
    metricData: any;
    metricsConfig: any;
    loading?: boolean;
    isDesktop: boolean;
}

export const AccountInfoMetric = ({
    metricData,
    metricsConfig,
    loading = false,
    isDesktop,
}: AccountInfoMetricProps) => {
    const { label, value } = getMetricViewProps(metricData, metricsConfig);

    return (
        <AccountInfoMetricWrapper isDesktop={isDesktop}>
            <AccountInfoMetricTitle isDesktop={isDesktop}>
                {label}
            </AccountInfoMetricTitle>
            <AccountInfoMetricValue isDesktop={isDesktop}>
                {loading ? (
                    <Loading
                        height={20}
                        spinnerSize={20}
                    />
                ) : (
                    value && (
                        <Fragment>
                            <CircleIcon
                                backgroundColor={ColorConstants.shamrock}
                                height="7px"
                                margin="0 7px 0 0"
                                width="7px"
                                x={null}
                                y={null}
                            />
                            {value}
                        </Fragment>
                    )
                )}
            </AccountInfoMetricValue>
        </AccountInfoMetricWrapper>
    );
};
